import React from 'react'
// import ThemeMenu from '../components/molecules/thememenu/ThemeMenu'

const Settings = () => {
    
    return (
        <div>
            <h2 className="page-header">
                Configuración de perfil
            </h2>
        </div>
    )
}

export default Settings
